import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 谈判采购
 * @type {import('@/router').RouteConfig}
 */
export default {
  path: 'negotiation',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '谈判采购',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
    { companyType: companyTypeDict.SELF_EMPLOYEE.value },
    { companyType: companyTypeDict.PERSON.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 项目列表
    {
      path: 'list',
      name: 'ParticipateNegotiation',
      component: '/supplier-views/participate/negotiation',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '项目列表',
        cache: true,
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 机场项目详情
    {
      path: 'orders/:orderId/info/trade/:tradeId?',
      name: 'SupplierNegotiationDetail',
      component: '/supplier-views/negotiation/common/detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '机场项目详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value, menuName: '项目详情' },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '项目详情'
        },
        {
          companyType: companyTypeDict.SELF_EMPLOYEE.value,
          menuName: '项目详情'
        },
        { companyType: companyTypeDict.PERSON.value, menuName: '项目详情' }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 机场报名详情
    {
      path: 'orders/:orderId/trade/:tradeId?',
      name: 'SupplierNegotiationTrade',
      component: '/supplier-views/negotiation/common/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '机场报名详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value, menuName: '报名详情' },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '报名详情'
        },
        {
          companyType: companyTypeDict.SELF_EMPLOYEE.value,
          menuName: '报名详情'
        },
        { companyType: companyTypeDict.PERSON.value, menuName: '报名详情' }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 机场变更公告
    {
      path: 'orders/:orderId/trade/change-detail',
      name: 'SupplierNegotiationChangeNotice',
      component: '/supplier-views/negotiation/common/change-notice',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '机场变更公告',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value, menuName: '变更公告' },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '变更公告'
        },
        {
          companyType: companyTypeDict.SELF_EMPLOYEE.value,
          menuName: '变更公告'
        },
        { companyType: companyTypeDict.PERSON.value, menuName: '变更公告' }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 机场谈判线上评审文件
    {
      path: 'orders/:orderId/online-review/file',
      name: 'SupplierNegotiationReviewFile',
      component: '/supplier-views/negotiation/common/online-review/review-file',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '线上评审文件',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value },
        { companyType: companyTypeDict.SELF_EMPLOYEE.value },
        { companyType: companyTypeDict.PERSON.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 医院项目详情
    {
      path: 'v2/orders/:orderId/info',
      name: 'SupplierNegotiationV2Detail',
      component: '/supplier-views/negotiation/v2/detail',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '医院项目详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value, menuName: '项目详情' },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '项目详情'
        },
        {
          companyType: companyTypeDict.SELF_EMPLOYEE.value,
          menuName: '项目详情'
        },
        { companyType: companyTypeDict.PERSON.value, menuName: '项目详情' }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 医院报名详情
    {
      path: 'v2/orders/:orderId/trade/:tradeId?',
      name: 'SupplierNegotiationV2Trade',
      component: '/supplier-views/negotiation/v2/index',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '医院报名详情',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value, menuName: '报名详情' },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '报名详情'
        },
        {
          companyType: companyTypeDict.SELF_EMPLOYEE.value,
          menuName: '报名详情'
        },
        { companyType: companyTypeDict.PERSON.value, menuName: '报名详情' }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
